import React from "react";
import { Form, Col } from "react-bootstrap";
import FilterationBarContainer from "../../../components/FilterationBarContainer";
import CustomReactSelect from "../../../components/CustomReactSelect";

const FilterationBar = (props) => {
  const {
    leaveTypes,
    selectedLeaveType,
    onLeaveTypeChange,
    AllEmployees,
    selectedEmployees,
    onEmployeeChange,
    LeavesStatus,
    selectedStatus,
    onStatusChange,
  } = props;

  return (
    <FilterationBarContainer>
      {/*Leave Type*/}
      <Col lg={4}>
        <Form.Group className="input-field">
          <Form.Label className="label">Leave Type</Form.Label>
          <Col>
            <CustomReactSelect
              options={leaveTypes}
              value={selectedLeaveType}
              onChange={(value) => onLeaveTypeChange(value)}
            />
          </Col>
        </Form.Group>
      </Col>

      {/*Employee Name*/}
      <Col lg={4}>
        <Form.Group className="input-field">
          <Form.Label className="label">Employee Name</Form.Label>
          <Col>
            <CustomReactSelect
              options={AllEmployees}
              value={selectedEmployees}
              onChange={(value) => onEmployeeChange(value)}
            />
          </Col>
        </Form.Group>
      </Col>

      {/*Application Status*/}
      <Col lg={4}>
        <Form.Group className="input-field">
          <Form.Label className="label">Application Status</Form.Label>
          <Col>
            <CustomReactSelect
              options={LeavesStatus}
              value={selectedStatus}
              onChange={(value) => onStatusChange(value)}
            />
          </Col>
        </Form.Group>
      </Col>
    </FilterationBarContainer>
  );
};

export default FilterationBar;
